module.exports = __webpack_public_path__ + "img/particle_motion_00111.5837779b.png";